export default class OutboundPaymentInitResponse{
    constructor(json) {
        this.redirectUrl = json['redirectUrl']
    }
}